import React, { useState, useEffect } from 'react'; // <-- Make sure useState is imported here
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { orderModules } from '../utils/moduleUtils';
import { handleSubmit } from '../service/handleSubmit';
import Button from '@mui/material/Button';
import BntDownloadDocumentation from './BntDownloadDocumentation';
import '@fontsource/open-sans';
import './RackPreview.css';
import BntTwin from './BntTwin';
import { deleteAllModule } from '../service/deleteModuleService';


/**
 * RackPreview component renders the preview of the rack configuration with selected modules and their submodules.
 * It calculates the total price and delivery time dynamically.
 *
 * @param {Object[]} selectedModules - List of selected modules.
 * @param {Function} handleSelectModule - Function to handle module selection.
 * @param {Function} onDelete - Function to handle the deletion of a module.
 * @param {Function} setSelectedModules - Function to update the selected modules.
 */

const RackPreview = ({ selectedModules, handleSelectModule, onDelete, setSelectedModules }) => {
  const [deliveryTime, setDeliveryTime] = useState(2);
  const [price, setPrice] = useState(2500);

/**
 * Updates delivery time when the selectedModules state changes.
 */

  useEffect(() => {
    
    setPrice((prevPrice) => {
      prevPrice=2500;
      let aux=0;
      selectedModules?.forEach(element => {
        aux += element['Price_€'];
        if (element.subModules && element.subModules.length>0) {
          element.subModules.forEach(element1 => {
            aux+=element1['Price_€'];
          });
        }
      });
      aux=aux*1.25;
      prevPrice+=aux
      return prevPrice;
    })
  }, [selectedModules])
 // Update delivery time when selectedModules changes
  useEffect(() => {
    if(selectedModules){
    setDeliveryTime((prevDeliveryTime) => {
      prevDeliveryTime=0;
      let max=0;
      selectedModules?.forEach(element => {
        if (element.LeadTime_WorkingDays>max) {
          max = element.LeadTime_WorkingDays;
        }
      });
      max+=60;
      prevDeliveryTime+=Math.round(max/30);
      prevDeliveryTime=Math.round(prevDeliveryTime);
      
      return prevDeliveryTime;
    })}
  }, [selectedModules])

/**
   * Calculate the total number of modules and submodules.
   * @type {Object}
   */
  const partNumberCount = selectedModules.reduce((acc, module) => {
    if (!acc[module.PartNumber]) {
      acc[module.PartNumber] = { count: 0, subModules: new Map() };
    }
    acc[module.PartNumber].count += 1;

    if (module.subModules) {
      module.subModules.forEach(subModule => {
        if (!acc[module.PartNumber].subModules.has(subModule.PartNumber)) {
          acc[module.PartNumber].subModules.set(subModule.PartNumber, 0);
        }
        acc[module.PartNumber].subModules.set(subModule.PartNumber, acc[module.PartNumber].subModules.get(subModule.PartNumber) + 1);
      });
    }

    return acc;
  }, {});

  const uniquePartNumbers = Object.keys(partNumberCount);
  

  /**
   * Handle the action to clear a specific module and update the selected modules list.
   *
   * @param {string} partNumber - The part number of the module to be cleared.
   */
  const handleClearModule = async (partNumber) => {
    setSelectedModules(await deleteAllModule(selectedModules, partNumber));
  };

  
  /**
   * Decrease the quantity of a specific submodule in the selected list.
   *
   * @param {string} subModulePartNumber - The part number of the submodule to decrement.
   */
  const handleClearSubModule = async (partNumber, subModulePartNumber) => {
    let module1 = selectedModules.find(m => m.PartNumber === partNumber && m.subModules[0]?.PartNumber.startsWith(subModulePartNumber.substring(0, 5)));
    module1.subModules = module1.subModules.filter(m => m.PartNumber !== subModulePartNumber);
    const u = await orderModules(selectedModules, handleSubmit);

    setSelectedModules(u);
  };
 
  /**
   * Decrease the quantity of a specific submodule in the selected list.
   *
   * @param {string} subModulePartNumber - The part number of the submodule to decrement.
   */
  const handleDecrementSubModule = async (subModulePartNumber) => {
    const modules = selectedModules.filter(m => m.PartNumber === '#137');
    const lastModule = modules.reverse().find(m => m.subModules.some(sm => sm.PartNumber === subModulePartNumber));
    if (lastModule) {
      const subModuleIndex = lastModule.subModules.findIndex(sm => sm.PartNumber === subModulePartNumber);
      if (subModuleIndex !== -1) {
        lastModule.subModules.splice(subModuleIndex, 1);
        const u = await orderModules(selectedModules);
        setSelectedModules(u);
      }
    }
  };


 /**
   * Clear all selected modules from the list.
   */
  const handleClearModules = () => {
    setSelectedModules([]);
  };

  /**
   * Increment the quantity of a specific submodule.
   *
   * @param {string} PartNumber - The part number of the parent module.
   * @param {string} subModulePartNumber - The part number of the submodule to increment.
   */

  const handleIncrementSubModule = (PartNumber, subModulePartNumber) => {
    let m1;
    selectedModules.forEach(m => {
      if (m.PartNumber === '#137' && !m1) {
        if (m1 = m.subModules.find(m2 => m2.PartNumber === subModulePartNumber)) {
          handleSelectModule(m1);
          return;
        }
      }
    });
  };
  return (
    <div style={{
      display: 'grid',
      gridTemplateRows: '1fr auto', // The layout is a grid with two rows: the first row is flexible, and the second row is fixed
      height: '100vh', // The container takes up the full height of the viewport
      gap: '10px', // There is a 10px gap between the rows
      backgroundColor: '#EDF5FB'
    }}>
  
      {/* First row - EGSE Configuration section */}
      <div style={{
        backgroundColor: '#EDF5FB',
        height: '100%',
        overflowY: 'auto', // Enables vertical scrolling if the content exceeds the height
        overflowX: 'hidden' // Hides horizontal scrolling
      }}>
        <div style={{
          padding: '1px',
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
          backgroundColor: '#2b8cb9',
          color: '#fff',
          textAlign: 'center',
          fontFamily: 'Open Sans',
          fontSize: '16px'
        }}>
          <h2 style={{ color: '#fff', textAlign: 'center', fontFamily: 'Open Sans' }}>
            EGSE Configuration {/* Header title for the configuration section */}
          </h2>
        </div>
  
        {/* Rack preview container */}
        <div className="rack-preview" style={{
          padding: '2%',
          backgroundColor: '#EDF5FB',
          overflowY: 'auto', // Enables scrolling for the module content
        }}>
          <div className="rack">
            {uniquePartNumbers.length > 0 ? uniquePartNumbers.map((partNumber, index) => {
              const { count, subModules } = partNumberCount[partNumber];
  
              return (
                // Each module block is displayed within the rack
                <div key={index} className="rack-module" style={{
                  height: '70%',
                  backgroundColor: '#fff',
                  border: '1px solid #1976d2',
                  color: '#1976d2',
                  textTransform: 'none',
                  fontSize: '16px',
                  fontWeight: 500,
                  boxShadow: 'none',
                }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {/* Part number and module count are displayed */}
                    <div style={{ flex: 1 }}>{partNumber}</div>
                    <div style={{ position: 'relative', right: '7%', color: 'black' }}>{count}</div>
  
                    {/* Control buttons for deleting or selecting a module */}
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div style={{ backgroundColor: '#fff', borderRadius: '10px' }}>
                        <button onClick={() => onDelete(selectedModules.find(m => m.PartNumber === partNumber))} style={{ backgroundColor: 'transparent', border: 'solid 1px #ddd' }}>
                          <RemoveCircleIcon style={{ color: '#0073CE' }} />
                        </button>
                        <button onClick={() => handleSelectModule(selectedModules.find(m => m.PartNumber === partNumber))} style={{ backgroundColor: 'transparent', border: 'solid 1px #ddd', }}>
                          <AddCircleIcon style={{ color: '#0073CE' }} />
                        </button>
                      </div>
                      <button className='ClearComponente' onClick={() => handleClearModule(partNumber)}>
                        <DeleteIcon style={{ color: '#EA3323' }} />
                      </button>
                    </div>
                  </div>
  
                  {/* Submodules associated with the part number are listed below */}
                  <div style={{ marginTop: '10px' }}>
                    {Array.from(subModules.keys()).map((subModulePartNumber, subIndex) => {
                      const subModuleCount = subModules.get(subModulePartNumber);
                      return (
                        <div key={subIndex} className="rack-submodule" style={{ marginLeft: '5%', display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                          {/* Submodule part number and count */}
                          <div style={{ flex: 1 }}>{subModulePartNumber}</div>
                          <div style={{ position: 'relative', right: '7%', color: 'black' }}>{subModuleCount}</div>
  
                          {/* Buttons for incrementing or decrementing submodule quantity */}
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <button onClick={() => handleDecrementSubModule(subModulePartNumber)} style={{ backgroundColor: 'transparent', border: 'solid 1px #ddd' }}>
                              <RemoveCircleIcon style={{ color: '#0073CE' }} />
                            </button>
                            <button onClick={() => { handleIncrementSubModule(partNumber, subModulePartNumber) }} style={{ backgroundColor: 'transparent', border: 'solid 1px #ddd' }}>
                              <AddCircleIcon style={{ color: '#0073CE' }} />
                            </button>
                          </div>
                          <button className='ClearComponente' onClick={() => handleClearSubModule(partNumber, subModulePartNumber)}>
                            <DeleteIcon style={{ color: '#EA3323' }} />
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            }) : <p style={{ textAlign: 'center' }}>No modules selected</p>}
          </div>
  
          {/* Button to clear all modules */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <Button variant="outlined" sx={{
              marginTop: '1%', marginBottom: '10%', padding: '5px 5px', backgroundColor: '#fff', fontFamily: 'Open Sans', boxShadow: 'none',
              '&:hover': {
                backgroundColor: '#e3f2fd',
                borderColor: '#1976d2',
              }
            }} startIcon={<DeleteIcon />} onClick={handleClearModules}>
              Clear All
            </Button>
          </div>
        </div>
      </div>
  
      {/* Second row - Price and delivery information */}
      <div className='ContainerPrice'>
        {/* Total price display */}
        <h3 style={{
          fontFamily: 'Open Sans', fontSize: '24px', margin: '5px 0', WebkitTextStroke: '0.1px #F8F8F8',
          textShadow: '0px 1px 1px #23430C'
        }}>
          Total Price: €{price.toFixed(2)}
        </h3>
        
        {/* Estimated delivery time */}
        <h5 style={{ fontFamily: 'Open Sans', fontSize: '16px', margin: '3px 0' }}>
          Estimated Lead Time: {deliveryTime} months
        </h5>
  
        {/* Download documentation and twin buttons */}
        <div className='Card_Documentation'>
          <BntDownloadDocumentation selectedModules={selectedModules} price={price} deliveryTime={deliveryTime} />
          <BntTwin />
        </div>
      </div>
    </div>
  );
}  

export default RackPreview;